import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { roofingServicePages } from "@/data/roofingServiceContent";

const c = roofingServicePages["roof-leak-repair"];

export const Route = createFileRoute("/services/roof-leak-repair")({
  head: () => ({
    meta: [
      { title: "Roof Leak Repair Southern California | McKay Roofing & Solar" },
      { name: "description", content: "Roof leak repair across Southern California – we track leaks to the real source and fix what's actually failing." },
      { property: "og:title", content: "Roof Leak Repair – McKay Roofing & Solar" },
      { property: "og:description", content: c.heroSubtitle },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/roof-leak-repair" }],
  }),
  component: () => <RoofingServicePage {...c} />,
});